// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA9dm7tjwkwGqg7cmcr39qcmkGXG6PZmqY",
  authDomain: "threetreevillabyhabarana-6d0f7.firebaseapp.com",
  projectId: "threetreevillabyhabarana-6d0f7",
  storageBucket: "threetreevillabyhabarana-6d0f7.firebasestorage.app",
  messagingSenderId: "692091077484",
  appId: "1:692091077484:web:868a734e61656be0306949",
  measurementId: "G-37Y522PYJ8"
};

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
